import {Ldtk} from '@theatrejs/plugin-ldtk';export default new Ldtk({
	"__header__": {
		"fileType": "LDtk Project JSON",
		"app": "LDtk",
		"doc": "https://ldtk.io/json",
		"schema": "https://ldtk.io/files/JSON_SCHEMA.json",
		"appAuthor": "Sebastien 'deepnight' Benard",
		"appVersion": "1.5.3",
		"url": "https://ldtk.io"
	},
	"iid": "d211b360-9b00-11ef-8143-dd7f077a4744",
	"jsonVersion": "1.5.3",
	"appBuildId": 473703,
	"nextUid": 87,
	"identifierStyle": "Free",
	"toc": [],
	"worldLayout": "Free",
	"worldGridWidth": 256,
	"worldGridHeight": 256,
	"defaultLevelWidth": 128,
	"defaultLevelHeight": 128,
	"defaultPivotX": 0.5,
	"defaultPivotY": 0.5,
	"defaultGridSize": 32,
	"defaultEntityWidth": 32,
	"defaultEntityHeight": 32,
	"bgColor": "#40465B",
	"defaultLevelBgColor": "#696A79",
	"minifyJson": false,
	"externalLevels": false,
	"exportTiled": false,
	"simplifiedExport": false,
	"imageExportMode": "None",
	"exportLevelBg": true,
	"pngFilePattern": null,
	"backupOnSave": true,
	"backupLimit": 10,
	"backupRelPath": ".ldtk",
	"levelNamePattern": "Stage%idx1",
	"tutorialDesc": null,
	"customCommands": [],
	"flags": [],
	"defs": { "layers": [
		{
			"__type": "Entities",
			"identifier": "actors",
			"type": "Entities",
			"uid": 64,
			"doc": null,
			"uiColor": null,
			"gridSize": 32,
			"guideGridWid": 0,
			"guideGridHei": 0,
			"displayOpacity": 1,
			"inactiveOpacity": 0.6,
			"hideInList": false,
			"hideFieldsWhenInactive": false,
			"canSelectWhenInactive": false,
			"renderInWorldView": true,
			"pxOffsetX": 0,
			"pxOffsetY": 0,
			"parallaxFactorX": 0,
			"parallaxFactorY": 0,
			"parallaxScaling": true,
			"requiredTags": ["actor"],
			"excludedTags": ["interaction"],
			"autoTilesKilledByOtherLayerUid": null,
			"uiFilterTags": [],
			"useAsyncRender": false,
			"intGridValues": [],
			"intGridValuesGroups": [],
			"autoRuleGroups": [],
			"autoSourceLayerDefUid": null,
			"tilesetDefUid": null,
			"tilePivotX": 0,
			"tilePivotY": 0,
			"biomeFieldUid": null
		}
	], "entities": [
		{
			"identifier": "Exit",
			"uid": 32,
			"tags": ["actor"],
			"exportToToc": false,
			"allowOutOfBounds": false,
			"doc": null,
			"width": 32,
			"height": 32,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#3E8948",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 52,
			"tileRenderMode": "FullSizeUncropped",
			"tileRect": { "tilesetUid": 52, "x": 256, "y": 160, "w": 16, "h": 16 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		},
		{
			"identifier": "Hero",
			"uid": 74,
			"tags": ["actor"],
			"exportToToc": false,
			"allowOutOfBounds": false,
			"doc": null,
			"width": 32,
			"height": 32,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#0099DB",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 52,
			"tileRenderMode": "FullSizeUncropped",
			"tileRect": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		},
		{
			"identifier": "Wall",
			"uid": 75,
			"tags": ["actor"],
			"exportToToc": false,
			"allowOutOfBounds": false,
			"doc": null,
			"width": 32,
			"height": 32,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#8B9BB4",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 52,
			"tileRenderMode": "FullSizeUncropped",
			"tileRect": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		},
		{
			"identifier": "Hole",
			"uid": 77,
			"tags": ["actor"],
			"exportToToc": false,
			"allowOutOfBounds": false,
			"doc": null,
			"width": 32,
			"height": 32,
			"resizableX": false,
			"resizableY": false,
			"minWidth": null,
			"maxWidth": null,
			"minHeight": null,
			"maxHeight": null,
			"keepAspectRatio": false,
			"tileOpacity": 1,
			"fillOpacity": 0.08,
			"lineOpacity": 0,
			"hollow": false,
			"color": "#8B9BB4",
			"renderMode": "Tile",
			"showName": true,
			"tilesetId": 52,
			"tileRenderMode": "FullSizeUncropped",
			"tileRect": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
			"uiTileRect": null,
			"nineSliceBorders": [],
			"maxCount": 0,
			"limitScope": "PerLevel",
			"limitBehavior": "MoveLastOne",
			"pivotX": 0.5,
			"pivotY": 0.5,
			"fieldDefs": []
		}
	], "tilesets": [
		{
			"__cWid": 32,
			"__cHei": 64,
			"identifier": "Internal_Icons",
			"uid": 52,
			"relPath": null,
			"embedAtlas": "LdtkIcons",
			"pxWid": 512,
			"pxHei": 1024,
			"tileGridSize": 16,
			"spacing": 0,
			"padding": 0,
			"tags": [],
			"tagsSourceEnumUid": null,
			"enumTags": [],
			"customData": [],
			"savedSelections": [],
			"cachedPixelData": {
				"opaqueTiles": "00000000000000000000000000000000000000000000000000000000000000000000000000000000111111111000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
				"averageColors": "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"
			}
		}
	], "enums": [], "externalEnums": [], "levelFields": [] },
	"levels": [
		{
			"identifier": "Stage3",
			"iid": "6e69f6d0-1030-11f0-b4de-ebea87f23d50",
			"uid": 73,
			"worldX": 0,
			"worldY": -384,
			"worldDepth": 0,
			"pxWid": 64,
			"pxHei": 96,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "actors",
					"__type": "Entities",
					"__cWid": 2,
					"__cHei": 3,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "6e69f6d1-1030-11f0-b4de-4b2694bf5076",
					"levelId": 73,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 915540,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "Hero",
							"__grid": [1,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#0099DB",
							"iid": "e51e25d0-1030-11f0-b4de-7357a5fd3c7c",
							"width": 32,
							"height": 32,
							"defUid": 74,
							"px": [48,80],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -304
						},
						{
							"__identifier": "Exit",
							"__grid": [0,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 256, "y": 160, "w": 16, "h": 16 },
							"__smartColor": "#3E8948",
							"iid": "e71eb0c0-1030-11f0-b4de-bd7d97c2dd86",
							"width": 32,
							"height": 32,
							"defUid": 32,
							"px": [16,16],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -368
						},
						{
							"__identifier": "Wall",
							"__grid": [0,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "9a7cf6e0-1030-11f0-b4de-9d527e50c64a",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [16,80],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -304
						},
						{
							"__identifier": "Wall",
							"__grid": [0,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "ab5b6270-1030-11f0-8a83-bffa6b363a16",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [16,48],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -336
						}
					]
				}
			],
			"__neighbours": []
		},
		{
			"identifier": "Stage2",
			"iid": "61e7af40-1030-11f0-b4de-a1b28ab8c483",
			"uid": 76,
			"worldX": 0,
			"worldY": -256,
			"worldDepth": 0,
			"pxWid": 128,
			"pxHei": 128,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "actors",
					"__type": "Entities",
					"__cWid": 4,
					"__cHei": 4,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "61e7af41-1030-11f0-b4de-ebaf25a1d409",
					"levelId": 76,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 2995607,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "Wall",
							"__grid": [1,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "75a42cc0-1030-11f0-b4de-336210f8a1df",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [48,112],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -144
						},
						{
							"__identifier": "Hero",
							"__grid": [1,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#0099DB",
							"iid": "7bfa0810-1030-11f0-b4de-c3a861177b7d",
							"width": 32,
							"height": 32,
							"defUid": 74,
							"px": [48,80],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -176
						},
						{
							"__identifier": "Exit",
							"__grid": [2,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 256, "y": 160, "w": 16, "h": 16 },
							"__smartColor": "#3E8948",
							"iid": "81658360-1030-11f0-b4de-d55b533d56a1",
							"width": 32,
							"height": 32,
							"defUid": 32,
							"px": [80,48],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -208
						},
						{
							"__identifier": "Wall",
							"__grid": [3,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "1ca38470-1030-11f0-8a83-279cbad0aca4",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [112,80],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -176
						},
						{
							"__identifier": "Wall",
							"__grid": [3,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "1ced5eb0-1030-11f0-8a83-0979ce13060f",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [112,48],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -208
						},
						{
							"__identifier": "Wall",
							"__grid": [0,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "a2099a50-1030-11f0-8a83-1151f9459c37",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [16,112],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -144
						},
						{
							"__identifier": "Wall",
							"__grid": [0,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "a2628fc0-1030-11f0-8a83-8b2a75adc6e0",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [16,80],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -176
						},
						{
							"__identifier": "Wall",
							"__grid": [0,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "a34f12a0-1030-11f0-8a83-6768be606d28",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [16,48],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -208
						},
						{
							"__identifier": "Wall",
							"__grid": [2,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "b02311c0-1030-11f0-8a83-c3d4b2f72b0a",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [80,112],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -144
						},
						{
							"__identifier": "Wall",
							"__grid": [0,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "800ee9e0-1030-11f0-8a83-bf07934b7c89",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [16,16],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -240
						},
						{
							"__identifier": "Wall",
							"__grid": [2,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "804c6810-1030-11f0-8a83-755fbc13f57b",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [80,16],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -240
						},
						{
							"__identifier": "Wall",
							"__grid": [1,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "80a02d60-1030-11f0-8a83-87c3063fbfc6",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [48,16],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -240
						},
						{
							"__identifier": "Wall",
							"__grid": [3,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "80dfa760-1030-11f0-8a83-c51bd7461ee5",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [112,16],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -240
						},
						{
							"__identifier": "Wall",
							"__grid": [3,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "c646dc30-1030-11f0-8a83-f939785132ff",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [112,112],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -144
						}
					]
				}
			],
			"__neighbours": []
		},
		{
			"identifier": "Stage1",
			"iid": "2a94d170-1030-11f0-a7eb-4965e3b08788",
			"uid": 78,
			"worldX": 0,
			"worldY": -96,
			"worldDepth": 0,
			"pxWid": 96,
			"pxHei": 96,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "actors",
					"__type": "Entities",
					"__cWid": 3,
					"__cHei": 3,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "2a94f880-1030-11f0-a7eb-513ac5c53244",
					"levelId": 78,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 6170071,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "Exit",
							"__grid": [2,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 256, "y": 160, "w": 16, "h": 16 },
							"__smartColor": "#3E8948",
							"iid": "39259bc0-1030-11f0-a7eb-4516ad48dfb5",
							"width": 32,
							"height": 32,
							"defUid": 32,
							"px": [80,48],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -48
						},
						{
							"__identifier": "Hero",
							"__grid": [0,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#0099DB",
							"iid": "3b253c50-1030-11f0-a7eb-93d52ab683e6",
							"width": 32,
							"height": 32,
							"defUid": 74,
							"px": [16,48],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -48
						},
						{
							"__identifier": "Wall",
							"__grid": [1,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "a47428b0-1030-11f0-a7eb-ff1e41155fd5",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [48,80],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -16
						},
						{
							"__identifier": "Wall",
							"__grid": [2,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "a4b02040-1030-11f0-a7eb-617f0724cc69",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [80,80],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -16
						},
						{
							"__identifier": "Wall",
							"__grid": [2,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "a5093cc0-1030-11f0-a7eb-277bbaecb509",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [80,16],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -80
						},
						{
							"__identifier": "Wall",
							"__grid": [1,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "a55b2d50-1030-11f0-a7eb-e394992a74a5",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [48,16],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -80
						},
						{
							"__identifier": "Wall",
							"__grid": [0,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "a5a70360-1030-11f0-a7eb-93befd819220",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [16,16],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -80
						},
						{
							"__identifier": "Wall",
							"__grid": [0,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "882f0d60-1030-11f0-a7eb-03c298a68d4e",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [16,80],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -16
						}
					]
				}
			],
			"__neighbours": []
		},
		{
			"identifier": "Stage4",
			"iid": "43662550-1030-11f0-a7eb-c1c1855bda3c",
			"uid": 79,
			"worldX": 0,
			"worldY": -544,
			"worldDepth": 0,
			"pxWid": 128,
			"pxHei": 128,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "actors",
					"__type": "Entities",
					"__cWid": 4,
					"__cHei": 4,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "43662551-1030-11f0-a7eb-db1b1bd1d401",
					"levelId": 79,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 3520923,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "Hero",
							"__grid": [0,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#0099DB",
							"iid": "5122afb0-1030-11f0-a7eb-95f08feec465",
							"width": 32,
							"height": 32,
							"defUid": 74,
							"px": [16,16],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -528
						},
						{
							"__identifier": "Exit",
							"__grid": [3,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 256, "y": 160, "w": 16, "h": 16 },
							"__smartColor": "#3E8948",
							"iid": "52d6c850-1030-11f0-a7eb-5f499e627382",
							"width": 32,
							"height": 32,
							"defUid": 32,
							"px": [112,16],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -528
						},
						{
							"__identifier": "Wall",
							"__grid": [1,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "54548eb0-1030-11f0-a7eb-7febcb5f8710",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [48,16],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -528
						},
						{
							"__identifier": "Wall",
							"__grid": [2,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "54a0b2e0-1030-11f0-a7eb-47d708ffcdc5",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [80,16],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -528
						},
						{
							"__identifier": "Wall",
							"__grid": [0,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "5d041170-1030-11f0-a7eb-f5b0d78ea37b",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [16,80],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -464
						},
						{
							"__identifier": "Wall",
							"__grid": [2,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "5dc2a680-1030-11f0-a7eb-77a319201401",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [80,48],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -496
						},
						{
							"__identifier": "Wall",
							"__grid": [0,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "5f9e4450-1030-11f0-a7eb-bdbaa5cff118",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [16,112],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -432
						},
						{
							"__identifier": "Wall",
							"__grid": [1,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "972bea80-1030-11f0-a7eb-07bae350fbd0",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [48,112],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -432
						},
						{
							"__identifier": "Wall",
							"__grid": [2,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "977883e0-1030-11f0-a7eb-630a3a94b6f3",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [80,112],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -432
						},
						{
							"__identifier": "Wall",
							"__grid": [3,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "97c48100-1030-11f0-a7eb-ab11d7351538",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [112,112],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -432
						}
					]
				}
			],
			"__neighbours": []
		},
		{
			"identifier": "Stage5",
			"iid": "b3fffb60-1030-11f0-a7eb-5146e690dfa6",
			"uid": 80,
			"worldX": 0,
			"worldY": -640,
			"worldDepth": 0,
			"pxWid": 192,
			"pxHei": 64,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "actors",
					"__type": "Entities",
					"__cWid": 6,
					"__cHei": 2,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "b3fffb61-1030-11f0-a7eb-73fc53eb543f",
					"levelId": 80,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 3501515,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "Hero",
							"__grid": [0,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#0099DB",
							"iid": "c097b4d0-1030-11f0-a7eb-651489e9fd55",
							"width": 32,
							"height": 32,
							"defUid": 74,
							"px": [16,48],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -592
						},
						{
							"__identifier": "Exit",
							"__grid": [5,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 256, "y": 160, "w": 16, "h": 16 },
							"__smartColor": "#3E8948",
							"iid": "c82f10d0-1030-11f0-a7eb-cb8ca189995d",
							"width": 32,
							"height": 32,
							"defUid": 32,
							"px": [176,48],
							"fieldInstances": [],
							"__worldX": 176,
							"__worldY": -592
						},
						{
							"__identifier": "Wall",
							"__grid": [0,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "cbdef970-1030-11f0-a7eb-0578737a3eb4",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [16,16],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -624
						},
						{
							"__identifier": "Wall",
							"__grid": [3,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "cfdadf30-1030-11f0-a7eb-c558ea815e76",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [112,48],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -592
						},
						{
							"__identifier": "Wall",
							"__grid": [2,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "d24a0a70-1030-11f0-a7eb-2334ba5909b3",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [80,48],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -592
						},
						{
							"__identifier": "Wall",
							"__grid": [5,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "d338fe50-1030-11f0-a7eb-dd1e112f1638",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [176,16],
							"fieldInstances": [],
							"__worldX": 176,
							"__worldY": -624
						}
					]
				}
			],
			"__neighbours": []
		},
		{
			"identifier": "Stage6",
			"iid": "27153c40-1030-11f0-a7eb-8911f4bbd3aa",
			"uid": 81,
			"worldX": 0,
			"worldY": -736,
			"worldDepth": 0,
			"pxWid": 288,
			"pxHei": 64,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "actors",
					"__type": "Entities",
					"__cWid": 9,
					"__cHei": 2,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "27153c41-1030-11f0-a7eb-db8fd6d21c00",
					"levelId": 81,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 9761868,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "Exit",
							"__grid": [4,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 256, "y": 160, "w": 16, "h": 16 },
							"__smartColor": "#3E8948",
							"iid": "33cd27e0-1030-11f0-a7eb-c5fb79eb8864",
							"width": 32,
							"height": 32,
							"defUid": 32,
							"px": [144,48],
							"fieldInstances": [],
							"__worldX": 144,
							"__worldY": -688
						},
						{
							"__identifier": "Hero",
							"__grid": [0,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#0099DB",
							"iid": "36535d90-1030-11f0-a7eb-2b4992ebba1b",
							"width": 32,
							"height": 32,
							"defUid": 74,
							"px": [16,48],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -688
						},
						{
							"__identifier": "Wall",
							"__grid": [1,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "3988e610-1030-11f0-a7eb-772548a50964",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [48,48],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -688
						},
						{
							"__identifier": "Wall",
							"__grid": [3,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "3fd0b7a0-1030-11f0-a7eb-d330648a6205",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [112,48],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -688
						},
						{
							"__identifier": "Wall",
							"__grid": [5,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "4045c090-1030-11f0-a7eb-8d8ad87c9ea5",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [176,48],
							"fieldInstances": [],
							"__worldX": 176,
							"__worldY": -688
						},
						{
							"__identifier": "Wall",
							"__grid": [7,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "435809a0-1030-11f0-a7eb-3ffa4e448b8d",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [240,48],
							"fieldInstances": [],
							"__worldX": 240,
							"__worldY": -688
						},
						{
							"__identifier": "Hole",
							"__grid": [2,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "4d79e110-1030-11f0-a7eb-07eefbb6d322",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [80,48],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -688
						},
						{
							"__identifier": "Hole",
							"__grid": [6,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "4e5f5f10-1030-11f0-a7eb-61643a5764a4",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [208,48],
							"fieldInstances": [],
							"__worldX": 208,
							"__worldY": -688
						}
					]
				}
			],
			"__neighbours": []
		},
		{
			"identifier": "Stage7",
			"iid": "775c2900-1030-11f0-a7eb-294a2ed33967",
			"uid": 82,
			"worldX": 0,
			"worldY": -928,
			"worldDepth": 0,
			"pxWid": 128,
			"pxHei": 160,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "actors",
					"__type": "Entities",
					"__cWid": 4,
					"__cHei": 5,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "775c2901-1030-11f0-a7eb-29850de6e485",
					"levelId": 82,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 2991036,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "Hero",
							"__grid": [0,4],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#0099DB",
							"iid": "860647b0-1030-11f0-a7eb-a3e6a3e910a2",
							"width": 32,
							"height": 32,
							"defUid": 74,
							"px": [16,144],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -784
						},
						{
							"__identifier": "Exit",
							"__grid": [2,4],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 256, "y": 160, "w": 16, "h": 16 },
							"__smartColor": "#3E8948",
							"iid": "88d3e6a0-1030-11f0-a7eb-175d8deebd3e",
							"width": 32,
							"height": 32,
							"defUid": 32,
							"px": [80,144],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -784
						},
						{
							"__identifier": "Hole",
							"__grid": [1,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "8bf5c010-1030-11f0-a7eb-c5212d435eae",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [48,80],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -848
						},
						{
							"__identifier": "Hole",
							"__grid": [1,4],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "9b102cc0-1030-11f0-a7eb-d7c25084bddd",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [48,144],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -784
						},
						{
							"__identifier": "Hole",
							"__grid": [1,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "9b618110-1030-11f0-a7eb-6968f1ec45fd",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [48,112],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -816
						},
						{
							"__identifier": "Hole",
							"__grid": [2,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "a12f67b0-1030-11f0-a7eb-f5514e6b1924",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [80,112],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -816
						},
						{
							"__identifier": "Wall",
							"__grid": [0,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "ae0a44a0-1030-11f0-a7eb-7bd826e6e79c",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [16,16],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -912
						},
						{
							"__identifier": "Wall",
							"__grid": [1,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "ae945c30-1030-11f0-a7eb-935356dc970b",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [48,16],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -912
						},
						{
							"__identifier": "Wall",
							"__grid": [2,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "af883210-1030-11f0-a7eb-47b9ac95bd95",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [80,16],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -912
						},
						{
							"__identifier": "Wall",
							"__grid": [3,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "b6b9ee70-1030-11f0-a7eb-5f51b0b7aa2a",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [112,16],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -912
						},
						{
							"__identifier": "Wall",
							"__grid": [3,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "b708d1c0-1030-11f0-a7eb-65f18924b768",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [112,48],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -880
						}
					]
				}
			],
			"__neighbours": []
		},
		{
			"identifier": "Stage8",
			"iid": "c5cce7a0-1030-11f0-a5e8-9bda8fb5851d",
			"uid": 83,
			"worldX": 0,
			"worldY": -1120,
			"worldDepth": 0,
			"pxWid": 160,
			"pxHei": 160,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "actors",
					"__type": "Entities",
					"__cWid": 5,
					"__cHei": 5,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "c5cd0eb0-1030-11f0-a5e8-99809123b3ef",
					"levelId": 83,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 850917,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "Hero",
							"__grid": [2,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#0099DB",
							"iid": "39ae95b0-1030-11f0-a5e8-2d953204440f",
							"width": 32,
							"height": 32,
							"defUid": 74,
							"px": [80,80],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -1040
						},
						{
							"__identifier": "Exit",
							"__grid": [0,0],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 256, "y": 160, "w": 16, "h": 16 },
							"__smartColor": "#3E8948",
							"iid": "4a61cad0-1030-11f0-a5e8-1949c87f6570",
							"width": 32,
							"height": 32,
							"defUid": 32,
							"px": [16,16],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -1104
						},
						{
							"__identifier": "Hole",
							"__grid": [0,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "6cdcd960-1030-11f0-a5e8-6739b4279a4d",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [16,48],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -1072
						},
						{
							"__identifier": "Hole",
							"__grid": [1,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "70cc3c00-1030-11f0-a5e8-d1ed5268876b",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [48,48],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -1072
						},
						{
							"__identifier": "Hole",
							"__grid": [2,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "71137e30-1030-11f0-a5e8-0ff1a5cf3068",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [80,48],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -1072
						},
						{
							"__identifier": "Hole",
							"__grid": [3,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "715a9950-1030-11f0-a5e8-0999e7d2f1bb",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [112,48],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -1072
						},
						{
							"__identifier": "Hole",
							"__grid": [3,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "71a20290-1030-11f0-a5e8-2d90d56a622b",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [112,80],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -1040
						},
						{
							"__identifier": "Hole",
							"__grid": [3,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "71e992e0-1030-11f0-a5e8-c9a7c516ec42",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [112,112],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -1008
						},
						{
							"__identifier": "Hole",
							"__grid": [2,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "722e15f0-1030-11f0-a5e8-a994a1544d08",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [80,112],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -1008
						},
						{
							"__identifier": "Hole",
							"__grid": [1,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "727f1c20-1030-11f0-a5e8-ddad045599df",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [48,112],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -1008
						}
					]
				}
			],
			"__neighbours": []
		},
		{
			"identifier": "Stage9",
			"iid": "f87b0960-1030-11f0-a5e8-ed41fbf3d848",
			"uid": 84,
			"worldX": 0,
			"worldY": -1312,
			"worldDepth": 0,
			"pxWid": 160,
			"pxHei": 160,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "actors",
					"__type": "Entities",
					"__cWid": 5,
					"__cHei": 5,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "f87b3070-1030-11f0-a5e8-990c07b95127",
					"levelId": 84,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 1775996,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "Hole",
							"__grid": [1,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "06c44360-1030-11f0-a5e8-47ab58a34353",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [48,48],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -1264
						},
						{
							"__identifier": "Hole",
							"__grid": [1,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "070baca0-1030-11f0-a5e8-e1a9ef26c4f6",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [48,80],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -1232
						},
						{
							"__identifier": "Hole",
							"__grid": [1,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "075f9900-1030-11f0-a5e8-bbaad1cfaee2",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [48,112],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -1200
						},
						{
							"__identifier": "Hole",
							"__grid": [2,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "07a22040-1030-11f0-a5e8-ad8826823161",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [80,112],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -1200
						},
						{
							"__identifier": "Hole",
							"__grid": [2,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "07e93b60-1030-11f0-a5e8-698af58dcdfe",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [80,80],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -1232
						},
						{
							"__identifier": "Hole",
							"__grid": [2,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "08305680-1030-11f0-a5e8-e7205199646f",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [80,48],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -1264
						},
						{
							"__identifier": "Hole",
							"__grid": [3,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "08728fa0-1030-11f0-a5e8-71df646f2f1c",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [112,48],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -1264
						},
						{
							"__identifier": "Hole",
							"__grid": [3,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "08b9aac0-1030-11f0-a5e8-d79386686831",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [112,80],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -1232
						},
						{
							"__identifier": "Hole",
							"__grid": [3,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "09064420-1030-11f0-a5e8-c744750eed00",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [112,112],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -1200
						},
						{
							"__identifier": "Hero",
							"__grid": [2,4],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#0099DB",
							"iid": "0ae98310-1030-11f0-a5e8-1b01eef03966",
							"width": 32,
							"height": 32,
							"defUid": 74,
							"px": [80,144],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -1168
						},
						{
							"__identifier": "Exit",
							"__grid": [3,4],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 256, "y": 160, "w": 16, "h": 16 },
							"__smartColor": "#3E8948",
							"iid": "0f8886a0-1030-11f0-a5e8-55051a5f1985",
							"width": 32,
							"height": 32,
							"defUid": 32,
							"px": [112,144],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -1168
						},
						{
							"__identifier": "Wall",
							"__grid": [2,4],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "1f06be30-1030-11f0-a5e8-dfbad04c753c",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [80,144],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -1168
						},
						{
							"__identifier": "Hero",
							"__grid": [1,4],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#0099DB",
							"iid": "253d2aa0-1030-11f0-a5e8-5f286ce9527d",
							"width": 32,
							"height": 32,
							"defUid": 74,
							"px": [48,144],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -1168
						}
					]
				}
			],
			"__neighbours": []
		},
		{
			"identifier": "Stage10",
			"iid": "3fcc5490-1030-11f0-a5e8-95aa56b3380f",
			"uid": 85,
			"worldX": 0,
			"worldY": -1568,
			"worldDepth": 0,
			"pxWid": 224,
			"pxHei": 224,
			"__bgColor": "#696A79",
			"bgColor": null,
			"useAutoIdentifier": false,
			"bgRelPath": null,
			"bgPos": null,
			"bgPivotX": 0.5,
			"bgPivotY": 0.5,
			"__smartColor": "#ADADB5",
			"__bgPos": null,
			"externalRelPath": null,
			"fieldInstances": [],
			"layerInstances": [
				{
					"__identifier": "actors",
					"__type": "Entities",
					"__cWid": 7,
					"__cHei": 7,
					"__gridSize": 32,
					"__opacity": 1,
					"__pxTotalOffsetX": 0,
					"__pxTotalOffsetY": 0,
					"__tilesetDefUid": null,
					"__tilesetRelPath": null,
					"iid": "3fcc5491-1030-11f0-a5e8-5d9928315971",
					"levelId": 85,
					"layerDefUid": 64,
					"pxOffsetX": 0,
					"pxOffsetY": 0,
					"visible": true,
					"optionalRules": [],
					"intGridCsv": [],
					"autoLayerTiles": [],
					"seed": 5877338,
					"overrideTilesetUid": null,
					"gridTiles": [],
					"entityInstances": [
						{
							"__identifier": "Hero",
							"__grid": [0,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 0, "y": 240, "w": 16, "h": 16 },
							"__smartColor": "#0099DB",
							"iid": "53815800-1030-11f0-a5e8-57a7ad07cf93",
							"width": 32,
							"height": 32,
							"defUid": 74,
							"px": [16,80],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -1488
						},
						{
							"__identifier": "Hole",
							"__grid": [5,4],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "7c10cc10-1030-11f0-a5e8-9f9b68fe7e10",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [176,144],
							"fieldInstances": [],
							"__worldX": 176,
							"__worldY": -1424
						},
						{
							"__identifier": "Hole",
							"__grid": [4,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "7c7e5af0-1030-11f0-a5e8-d7c72440ab2a",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [144,48],
							"fieldInstances": [],
							"__worldX": 144,
							"__worldY": -1520
						},
						{
							"__identifier": "Hole",
							"__grid": [5,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "7ccd3e40-1030-11f0-a5e8-eff182e91539",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [176,48],
							"fieldInstances": [],
							"__worldX": 176,
							"__worldY": -1520
						},
						{
							"__identifier": "Exit",
							"__grid": [6,4],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 256, "y": 160, "w": 16, "h": 16 },
							"__smartColor": "#3E8948",
							"iid": "857260c0-1030-11f0-a5e8-992bc17d0da9",
							"width": 32,
							"height": 32,
							"defUid": 32,
							"px": [208,144],
							"fieldInstances": [],
							"__worldX": 208,
							"__worldY": -1424
						},
						{
							"__identifier": "Hole",
							"__grid": [5,5],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "88381070-1030-11f0-a5e8-83404af0806a",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [176,176],
							"fieldInstances": [],
							"__worldX": 176,
							"__worldY": -1392
						},
						{
							"__identifier": "Hole",
							"__grid": [6,5],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "88939df0-1030-11f0-a5e8-7d3e4e4e0228",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [208,176],
							"fieldInstances": [],
							"__worldX": 208,
							"__worldY": -1392
						},
						{
							"__identifier": "Hole",
							"__grid": [3,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "a831cb50-1030-11f0-a5e8-99c8dc53b8a1",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [112,48],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -1520
						},
						{
							"__identifier": "Wall",
							"__grid": [0,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "b1bba880-1030-11f0-a5e8-8d951b2cea62",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [16,48],
							"fieldInstances": [],
							"__worldX": 16,
							"__worldY": -1520
						},
						{
							"__identifier": "Wall",
							"__grid": [1,1],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "b2822cd0-1030-11f0-a5e8-49cbfe2a8468",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [48,48],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -1520
						},
						{
							"__identifier": "Wall",
							"__grid": [1,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "b2e81a90-1030-11f0-a5e8-35f481efcd6f",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [48,80],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -1488
						},
						{
							"__identifier": "Wall",
							"__grid": [1,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "b336d6d0-1030-11f0-a5e8-8b1e934c998b",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [48,112],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -1456
						},
						{
							"__identifier": "Wall",
							"__grid": [1,5],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "b3a43ea0-1030-11f0-a5e8-8f1281be379d",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [48,176],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -1392
						},
						{
							"__identifier": "Wall",
							"__grid": [2,5],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "b3f544d0-1030-11f0-a5e8-9fe6e8804eca",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [80,176],
							"fieldInstances": [],
							"__worldX": 80,
							"__worldY": -1392
						},
						{
							"__identifier": "Hole",
							"__grid": [5,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "bde054d0-1030-11f0-a5e8-f35e59958c89",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [176,80],
							"fieldInstances": [],
							"__worldX": 176,
							"__worldY": -1488
						},
						{
							"__identifier": "Hole",
							"__grid": [5,3],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "be27be10-1030-11f0-a5e8-6d4aa21b7ed0",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [176,112],
							"fieldInstances": [],
							"__worldX": 176,
							"__worldY": -1456
						},
						{
							"__identifier": "Wall",
							"__grid": [1,4],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "bfc604c0-1030-11f0-a5e8-3ff9e9004399",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [48,144],
							"fieldInstances": [],
							"__worldX": 48,
							"__worldY": -1424
						},
						{
							"__identifier": "Hole",
							"__grid": [3,2],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 48, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "cfb8f720-1030-11f0-a5e8-070f235f39dd",
							"width": 32,
							"height": 32,
							"defUid": 77,
							"px": [112,80],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -1488
						},
						{
							"__identifier": "Wall",
							"__grid": [3,4],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "d098cfd0-1030-11f0-a5e8-87bc0e1f7b71",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [112,144],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -1424
						},
						{
							"__identifier": "Wall",
							"__grid": [3,5],
							"__pivot": [0.5,0.5],
							"__tags": ["actor"],
							"__tile": { "tilesetUid": 52, "x": 368, "y": 32, "w": 16, "h": 16 },
							"__smartColor": "#8B9BB4",
							"iid": "d1366f60-1030-11f0-a5e8-c93f8f142f2b",
							"width": 32,
							"height": 32,
							"defUid": 75,
							"px": [112,176],
							"fieldInstances": [],
							"__worldX": 112,
							"__worldY": -1392
						}
					]
				}
			],
			"__neighbours": []
		}
	],
	"worlds": [],
	"dummyWorldIid": "d211da70-9b00-11ef-8143-f94a2cc595d5"
});